"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("@kyruus/button"));
var _propTypes = require("prop-types");
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MultiSelect = _ref => {
  var _context;
  let {
    options,
    onAnswer,
    ariaDescribedby
  } = _ref;
  const [answer, setAnswer] = (0, _react.useState)([]);
  return /*#__PURE__*/_react.default.createElement(_styles.MultiSelectContainer, null, /*#__PURE__*/_react.default.createElement(_styles.OptionList, {
    "aria-describedby": ariaDescribedby
  }, (0, _map.default)(_context = (0, _filter.default)(options).call(options, v => v.value && v.label)).call(_context, option => /*#__PURE__*/_react.default.createElement(_styles.Label, {
    htmlFor: `check-${option.value}`,
    key: option.value
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    id: `check-${option.value}`,
    value: option.value,
    onChange: () => {
      const set = new _set.default(answer);
      if (set.has(option.value)) {
        set.delete(option.value);
      } else {
        set.add(option.value);
      }
      setAnswer((0, _from.default)(set));
    }
  }), option.label))), /*#__PURE__*/_react.default.createElement(_button.default, {
    mode: "primary",
    onClick: () => onAnswer(answer)
  }, "Next"));
};
MultiSelect.propTypes = {
  // list of buttons to display
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: _propTypes.string,
    label: _propTypes.string
  })).isRequired,
  // callback when the input is answered, accepts an array containing the selected value
  onAnswer: _propTypes.func.isRequired,
  // if an answer is provided, it's passed down in an array
  answer: (0, _propTypes.arrayOf)(_propTypes.string),
  ariaDescribedby: _propTypes.string.isRequired
};
var _default = exports.default = MultiSelect;
MultiSelect.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MultiSelect",
  "props": {
    "options": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "value": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "onAnswer": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "answer": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "ariaDescribedby": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};